var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import LgTable from './LgTable';
import { defaultProps } from './defaults';
import { Provider, create } from 'mini-store';
import SelectionBox from './SelectionBox';
import SelectionCheckboxAll from './SelectionCheckboxAll';
import { SpanTag } from '../../Utils/AtomicTag';
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.getRecordKey = function (record, index) {
            var rowKey = _this.props.rowKey;
            // @ts-ignore
            var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
            return key === undefined ? index : key;
        };
        _this.renderSelectionBox = function (type) {
            return function (record, _, index) {
                var rowKey = _this.getRecordKey(record, index);
                var props = _this.getCheckboxPropsByItem(record, index);
                var handleChange = function (e) {
                    return type === 'radio'
                        ? _this.handleRadioSelect(record, index)
                        : _this.handleSelect(record, index, e);
                };
                return (React.createElement(SelectionBox, __assign({ rowIndex: rowKey, type: type, store: _this.store, onChange: handleChange }, props)));
            };
        };
        _this.handleSelectRow = function (selectionKey) {
            var data = _this.props.data;
            var selectedRowKeys = _this.store.getState().selectedRowKeys;
            var changeableRowKeys = data
                .filter(function (item, i) { return !_this.getCheckboxPropsByItem(item, i).disabled; })
                .map(function (item, i) { return _this.getRecordKey(item, i); });
            switch (selectionKey) {
                case 'all':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) < 0) {
                            selectedRowKeys.push(key);
                        }
                    });
                    break;
                case 'removeAll':
                    changeableRowKeys.forEach(function (key) {
                        if (selectedRowKeys.indexOf(key) >= 0) {
                            selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
                        }
                    });
                    break;
            }
            _this.setSelectedRowKeys(selectedRowKeys);
        };
        _this.handleClick = function (column) {
            if (!column.sorter)
                return;
            var _a = _this.state, sortOrder = _a.sortOrder, sortColumn = _a.sortColumn;
            var _b = _this.props, onChange = _b.onChange, data = _b.data;
            var sortDirections = column.sortDirections || _this.props.sortDirections;
            var newSortOrder;
            if (_this.isSameColumn(sortColumn, column) && sortOrder !== undefined) {
                var methodIndex = sortDirections.indexOf(sortOrder) + 1;
                newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
            }
            else {
                newSortOrder = sortDirections[0];
            }
            var newData = data || [];
            newData = newData.slice(0);
            var sorterFn = _this.getSorterFn(_this.state);
            if (sorterFn) {
                newData = _this.recursiveSort(newData, sorterFn);
            }
            _this.setState({
                sortOrder: newSortOrder,
                sortColumn: newSortOrder ? column : null,
            }, function () {
                if (onChange) {
                    onChange(_this.store.getState().paginationDataForChange, _this.state.sortColumn, {
                        data: Table.sortDataForChange,
                        action: 'sort',
                    });
                }
            });
        };
        _this.renderColumnsDropdown = function (columns) {
            return columns.map(function (column, i) {
                var onHeaderCell = column.onHeaderCell;
                if (column.sorter) {
                    onHeaderCell = function () { return _this.handleClick(column); };
                    return __assign(__assign({}, column), { title: (React.createElement("span", null,
                            column.title,
                            _this.renderSort(column))), onHeaderCell: onHeaderCell });
                }
                else {
                    return __assign(__assign({}, column), { title: column.title });
                }
            });
        };
        _this.renderComponent = function () {
            var _a = _this.props, columns = _a.columns, data = _a.data, rowSelection = _a.rowSelection, scroll = _a.scroll, expandedRowRender = _a.expandedRowRender, expandIconAsCell = _a.expandIconAsCell, useFixedHeader = _a.useFixedHeader, pagination = _a.pagination, rowClassName = _a.rowClassName, showHeader = _a.showHeader, title = _a.title, footer = _a.footer, rowKey = _a.rowKey, className = _a.className, style = _a.style, sortDirections = _a.sortDirections, rest = __rest(_a, ["columns", "data", "rowSelection", "scroll", "expandedRowRender", "expandIconAsCell", "useFixedHeader", "pagination", "rowClassName", "showHeader", "title", "footer", "rowKey", "className", "style", "sortDirections"]);
            var checkboxAllDisabled = data.every(function (item, index) { return _this.getCheckboxPropsByItem(item, index).disabled; });
            if (rowSelection) {
                var changeableData = data.filter(function (item, index) {
                    if (rowSelection.getCheckboxProps) {
                        return !_this.getCheckboxPropsByItem(item, index).disabled;
                    }
                    return true;
                });
                var len = columns.filter(function (item) { return item.key === 'selection-column'; }).length;
                if (len === 0) {
                    columns.unshift({
                        key: 'selection-column',
                        render: _this.renderSelectionBox(rowSelection.type),
                        width: rowSelection.columnWidth,
                        title: rowSelection.type === 'radio' ? (rowSelection.columnTitle) : (React.createElement(SelectionCheckboxAll, { disabled: checkboxAllDisabled, onSelect: _this.handleSelectRow, data: changeableData, store: _this.store, getRecordKey: _this.getRecordKey })),
                    });
                }
            }
            var newData = data || [];
            newData = newData.slice(0);
            var sorterFn = _this.getSorterFn(_this.state);
            if (sorterFn) {
                newData = _this.recursiveSort(newData, sorterFn);
                Table.sortDataForChange = newData;
            }
            return (React.createElement(LgTable, __assign({ columns: _this.renderColumnsDropdown(columns), data: newData, name: Table.NAME, rowSelection: rowSelection, scroll: scroll, expandedRowRender: expandedRowRender, expandIconAsCell: expandIconAsCell, useFixedHeader: useFixedHeader, pagination: pagination, rowClassName: rowClassName, showHeader: showHeader, title: title, footer: footer, rowKey: rowKey, className: className, style: style, sortDirections: sortDirections }, rest)));
        };
        _this.store = create({
            selectedRowKeys: [],
            fixedColumnsHeadRowsHeight: [],
            fixedColumnsBodyRowsHeight: [],
            paginationDataForChange: {},
        });
        var sortColumnArr = _this.props.columns.filter(function (column) { return column.defaultSortOrder != null; });
        _this.state = {
            sortOrder: sortColumnArr[0] ? sortColumnArr[0].defaultSortOrder : null,
            sortColumn: sortColumnArr[0] || null,
        };
        return _this;
    }
    Table.prototype.getCheckboxPropsByItem = function (item, index) {
        var rowSelection = this.props.rowSelection || {};
        if (!rowSelection.getCheckboxProps) {
            return {};
        }
        var key = this.getRecordKey(item, index);
        var CheckboxPropsCache = {};
        if (!CheckboxPropsCache[key]) {
            CheckboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
        }
        return CheckboxPropsCache[key];
    };
    Table.prototype.setSelectedRowKeys = function (selectedRowKeys) {
        var _this = this;
        var rowSelection = this.props.rowSelection || {};
        var data = this.props.data;
        if (rowSelection) {
            this.store.setState({ selectedRowKeys: selectedRowKeys });
        }
        var selectedRows = data.filter(function (row, i) { return selectedRowKeys.indexOf(_this.getRecordKey(row, i)) >= 0; });
        if (rowSelection.onChange) {
            rowSelection.onChange(selectedRowKeys, selectedRows);
        }
    };
    Table.prototype.handleRadioSelect = function (record, rowIndex) {
        var key = this.getRecordKey(record, rowIndex);
        var selectedRowKeys = [key];
        this.setSelectedRowKeys(selectedRowKeys);
    };
    Table.prototype.handleSelect = function (record, rowIndex, e) {
        var checked = e.target.checked;
        var selectedRowKeys = this.store.getState().selectedRowKeys;
        var key = this.getRecordKey(record, rowIndex);
        var realIndex = rowIndex;
        if (checked) {
            selectedRowKeys.push(this.getRecordKey(record, realIndex));
        }
        else {
            selectedRowKeys = selectedRowKeys.filter(function (i) { return key !== i; });
        }
        this.setSelectedRowKeys(selectedRowKeys);
    };
    Table.prototype.getColumnKey = function (column, index) {
        return column.key || column.dataIndex || index;
    };
    Table.prototype.isSortColumn = function (column) {
        var sortColumn = this.state.sortColumn;
        if (!column || !sortColumn) {
            return false;
        }
        return this.getColumnKey(sortColumn) === this.getColumnKey(column);
    };
    Table.prototype.shallowEqual = function (objA, objB, compare, compareContext) {
        var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
        if (ret !== void 0) {
            return !!ret;
        }
        if (objA === objB) {
            return true;
        }
        if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
            return false;
        }
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
            return false;
        }
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
        // Test for A's keys different from B.
        for (var idx = 0; idx < keysA.length; idx++) {
            var key = keysA[idx];
            if (!bHasOwnProperty(key)) {
                return false;
            }
            var valueA = objA[key];
            var valueB = objB[key];
            ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
            if (ret === false || (ret === void 0 && valueA !== valueB)) {
                return false;
            }
        }
        return true;
    };
    Table.prototype.isSameColumn = function (a, b) {
        if (a && b && a.key && a.key === b.key) {
            return true;
        }
        return (a === b ||
            this.shallowEqual(a, b, function (value, other) {
                if (typeof value === 'function' && typeof other === 'function') {
                    return value === other || value.toString() === other.toString();
                }
            }));
    };
    Table.prototype.renderSort = function (column) {
        if (!column.sorter)
            return null;
        var _a = column.sortDirections, sortDirections = _a === void 0 ? ['descend', 'ascend'] : _a;
        var sortOrder = this.state.sortOrder;
        var isSortColumn = this.isSortColumn(column);
        var isAscend = isSortColumn && sortOrder === 'ascend';
        var isDescend = isSortColumn && sortOrder === 'descend';
        var caretWrapperStyle = {};
        if (sortDirections.toString() === ['ascend'].toString() ||
            sortDirections.toString() === ['descend'].toString()) {
            caretWrapperStyle.marginTop = '-6px';
        }
        return (React.createElement(SpanTag, { autoPrefixedClassName: "caret-wrapper", style: caretWrapperStyle },
            sortDirections.indexOf('ascend') > -1 && (React.createElement("i", { className: "sort-caret ascending " + (isAscend ? 'on' : '') })),
            sortDirections.indexOf('descend') > -1 && (React.createElement("i", { className: "sort-caret descending " + (isDescend ? 'on' : '') }))));
    };
    Table.prototype.getSorterFn = function (state) {
        var _a = state || this.state, sortOrder = _a.sortOrder, sortColumn = _a.sortColumn;
        if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
            return;
        }
        return function (a, b) {
            var result = sortColumn.sorter(a, b, sortOrder);
            if (result !== 0) {
                return sortOrder === 'descend' ? -result : result;
            }
            return 0;
        };
    };
    Table.prototype.recursiveSort = function (data, sorterFn) {
        var _this = this;
        var _a = this.props.childrenColumnName, childrenColumnName = _a === void 0 ? 'children' : _a;
        return data.sort(sorterFn).map(function (item) {
            var _a;
            return item[childrenColumnName]
                ? __assign(__assign({}, item), (_a = {}, _a[childrenColumnName] = _this.recursiveSort(item[childrenColumnName], sorterFn), _a)) : item;
        });
    };
    Table.prototype.render = function () {
        return React.createElement(Provider, { store: this.store }, this.renderComponent());
    };
    Table.defaultProps = defaultProps;
    Table.NAME = 'table';
    Table.displayName = 'Table';
    Table.sortDataForChange = []; // 存储执行 onChange 时需要输出的 data
    return Table;
}(Component));
export { Table };
